import { render, staticRenderFns } from "./ProductTypeDefinition.vue?vue&type=template&id=494f44d9&"
import script from "./ProductTypeDefinition.vue?vue&type=script&lang=js&"
export * from "./ProductTypeDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports